import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ToastModule } from 'primeng';
import { OrderLimitsAdminComponent } from './order-limits-admin/order-limits-admin.component';

const routes: Routes = [
  { path: '', component: OrderLimitsAdminComponent, data: { title: 'Order Limits Admin' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerOrderLimitsRoutingModule {}

@NgModule({
  imports: [
    CustomerOrderLimitsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [OrderLimitsAdminComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerOrderLimitsModule {}
